import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { CookieService } from 'ngx-cookie-service';

import { AuthQuery } from './auth.query';
import { AuthStore } from './auth.store';
import { TokenService } from '@app/@core/services/token.service';
import { JournalService } from '@app/@core';
import { Logger } from '@core';

const log = new Logger('AuthenticationGuard');

@Injectable({
  providedIn: 'root',
})
export class AuthenticationGuard {
  constructor(
    private router: Router,
    private authQuery: AuthQuery,
    private authStore: AuthStore,
    private tokenService: TokenService,
    private cookieService: CookieService,
    private journalService: JournalService
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | boolean {
    if (!this.authQuery.isLoggedIn) {
      this.redirectToLogin(state.url);
      return false;
    }

    if (!this.tokenService.isTokenExpired() && !this.tokenService.shouldRefreshToken()) {
      return this.finishAllowedAccess();
    }

    const refreshToken = this.authStore.getValue().refresh_token;
    if (!refreshToken) {
      this.authStore.remove();
      this.redirectToLogin(state.url);
      return false;
    }

    return this.tokenService.refreshToken().pipe(
      map(() => this.finishAllowedAccess()),
      catchError(() => {
        this.redirectToLogin(state.url);
        return of(false);
      })
    );
  }

  private finishAllowedAccess(): boolean {
    const wasHere = this.cookieService.get('logged-on-today');
    if (wasHere !== '1') {
      this.cookieService.set('logged-on-today', '1', {
        expires: 60 * 60 * 12,
      });
      console.log('login mit remember me');
      this.journalService.log('Anmeldung mit Remember Me Funktion -------------', '', '');
    }

    const firststart = true;
    if (!firststart) {
      this.router.navigate(['/firststart'], {
        queryParams: { redirect: this.router.url },
        replaceUrl: true,
      });
      return false;
    }

    return true;
  }

  private redirectToLogin(redirectUrl: string): void {
    log.debug('Not authenticated, redirecting and adding redirect url...');
    this.router.navigate(['/login'], {
      queryParams: { redirect: redirectUrl },
      replaceUrl: true,
    });
  }
}
